import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruth8patchPatchScreenTruthScreensAppIdQueryPolicyResponseSchema = jsonObject
export type tcpscreentruth8patchPatchScreenTruthScreensAppIdQueryPolicyResponse = z.infer<typeof tcpscreentruth8patchPatchScreenTruthScreensAppIdQueryPolicyResponseSchema>
export const tcpscreentruth8patchPatchScreenTruthScreensAppIdNavRuleResponseSchema = jsonObject
export type tcpscreentruth8patchPatchScreenTruthScreensAppIdNavRuleResponse = z.infer<typeof tcpscreentruth8patchPatchScreenTruthScreensAppIdNavRuleResponseSchema>
